import ajax from "@/sy/app.ajax.js";

let filechunk =
{
    hello: function()
    {
        console.log("Hello: sy.filechunk");
    },

    /**
     * [name]			file		文件实例
     * [name]			url			上传地址: 默认 "/web/base/app.filechunk.php"
     * [note]			可能未来还会修改- 怕有什么 初始配置
     *
     */
    init: function( options )
    {
        this.url = "/web/base/app.filechunk.php";   // 服务地址

        this.data  = {};         					// 附加数据
        this.file  = {};         					// 文件对象
        this.chunk = {};							// 子块分割
        this.chunk_num   = 0;						// 第几块
        this.chunk_sum   = 0;						// 块总数
        this.chunk_start = 0;						// 开始位置
        this.chunk_end   = 0;						// 结束位置 - 临时作用
        this.chunk_size  = 1024 * 1000 * 1;			// 子块大小 nginx 默认 1m 预留一部分传递参数

        if( options !== undefined )
        {
            for(var k in options)
            {
                this[k] = options[k];
            }
        }
		// 如果包含文件 执行上传
		if( options.file !== undefined )
		{
			this.onFile( options.file );
		}
    },
	// 支持单独 配置 文件对象
	onFile: function(file)
	{
		if( file === undefined )
		{
			return console.log("没有文件");
		}
		this.file = file;
		this.chunk_name  = this.file.name;
		this.chunk_sum   = Math.ceil( this.file.size / this.chunk_size );

		this.sendFile();
	},
    sendFile: function()
    {
        if( this.chunk_sum === this.chunk_num )
        {
            return console.log("终止上传");
        }

        this.cutFile();

        let data =
        {
            "chunk_num": this.chunk_num,
            "chunk_sum": this.chunk_sum,
            "chunk_name": this.chunk_name,
            "file":
            {
                "name": "sy_file",
                "file": this.chunk,
            },
        }
        // 附加数据
        if( this.data !== undefined )
        {
            for(var k in this.data)
            {
                data[k] = this.data[k];
            }
        }
        
        ajax.file({
            url: this.url,
            data: data,
        }).then(res => {

            console.log(res);
            filechunk.success(res);
        });

    },
    cutFile: function()
    {
        this.chunk_end = this.chunk_start + this.chunk_size;
        this.chunk = this.file.slice( this.chunk_start, this.chunk_end );
        this.chunk_start = this.chunk_end;
        this.chunk_num++;
    },
    loopSend: function()
    {
        setTimeout(function()
        {
            filechunk.sendFile();
        }, 500);
    },

    // 回调模块
    success: function(res)
    {
        // 监控模块
        // filechunk.monitor();
        console.log( this.chunk_num + "/" + this.chunk_sum );

        // console.log( res );
        if( res.state === '1' )
        {
            return filechunk.progress(res);
        }
        if( res.state === '2' )
        {
            return filechunk.loopSend();
        }
        //alert( res.msg );
    },

    // 回调模块
    progress: function(res)
    {
        console.log( res );
    },
};

export default filechunk;